import React from 'react'
import * as inputStyles from '../../styles/project-modules/bills/giveinput.module.less'
import Person from './Person'
import Table from '../elements/Table'
import Calendar from './Calendar'
import {
  intro,
  contact,
  author,
  // hearing,
} from '../../data/LegisTracker_all_states_text.json'
import SafeLink from '../sfc/safelink'
import Personalizer from '../personalize/Personalizer'
import storySettings from '../../data/story_settings.sheet.json'


function GiveInput({ bill, yourLegislators, setYourLegislators, MARKET_KEY }) {
  let { sponsors, calendar } = bill


  const yourLegislatorsOCD_IDS = yourLegislators
    ? yourLegislators.map((l) => l.ocd_id)
    : null

  //filter out committees because they can't be contacted
  sponsors = sponsors.filter(s => !s.committee);
  let sponsorTableData = sponsors.map((s) => ({
    Lawmaker: (
      <Person
        name={s.committee_name ? `${s.committee_name} Committee` : s.name}
        district={s.district}
        className={`${inputStyles.sponsorListItem} ${
          yourLegislatorsOCD_IDS && yourLegislatorsOCD_IDS.includes(s.ocd_id)
            ? inputStyles.highlight
            : ''
        }`}
        // img={s.photoUrl}
        party={s.party_id}
      />
    ),
    Contact: [
      s.contact_info && s.contact_info.email ? (
            <span><a href={`mailto:${s.contact_info['email']}`}>Email</a></span>
          ) : null,
      s.contact_info && s.contact_info.phone ? <span><SafeLink href={'tel:' + s.contact_info.phone}>{s.contact_info.phone}</SafeLink></span> : null,
      s.contact_info && s.contact_info['Twitter'] ? (
        <span><SafeLink href={'https://twitter.com/' + s.contact_info['Twitter']} withinSite={false}>Twitter</SafeLink></span>
        ) : null,
      s.contact_info && s.contact_info['Facebook'] ? (
        <span><SafeLink href={'https://www.facebook.com/' + s.contact_info['Facebook']} withinSite={false}>Facebook</SafeLink></span>
          ) : null
    ]
  }))

  let yourLawmakersTableData = yourLegislators
    ? yourLegislators.map((s) => ({
        Lawmaker: (
          <Person
            name={s.name}
            district={s.district}
            className={inputStyles.sponsorListItem}
            // img={s.photo_url}
            party={s.party_id}
            MARKET_KEY={MARKET_KEY}
          />
        ),
        Contact: [
          s.email ? <span><a href={`mailto:${s['email']}`}>Email</a></span> : null,
          s.phone ? <span><SafeLink href={'tel:' + s['phone']}>{s['phone']}</SafeLink></span> : null,
          s['Twitter'] && (
              <span><SafeLink href={'https://twitter.com/' + s['Twitter']} withinSite={false}>Twitter</SafeLink></span>
            ),
          s['Facebook'] && (
              <span><SafeLink href={'https://www.facebook.com/' + s['Facebook']} withinSite={false}>Facebook</SafeLink></span>
            )
        ]
      }))
    : null

  return (
    <div className={inputStyles.container}>
      <p className={inputStyles.text}>{intro}</p>
      { (yourLegislators && yourLegislators.length > 0) ? (
        <>
          <h4 className={inputStyles.subhed}>{contact.header}</h4>
          <p className={inputStyles.text}>{contact.text}</p>
          <div className={inputStyles.personContainer}>
            <Table
              data={yourLawmakersTableData}
              // useKeys={['Lawmaker', 'Email', 'Phone', 'Facebook', 'Twitter']}
              useKeys={['Lawmaker', 'Contact']}
              type={'contact'}
            />
          </div>
          <em><p className={inputStyles.dataSource}>Source: Google Civic Information API</p></em>
        </>
      ) : (
        <>
          <h4 className={inputStyles.subhed}>{contact.header}</h4>
          {/* <a href="../../#personalizer">
            Highlight your legislators by entering your address on the main page.
          </a> */}
          <Personalizer
              yourLegislators={yourLegislators}
              setYourLegislators={setYourLegislators}
              MARKET_KEY={MARKET_KEY}
              billPage={true}
            />
        </>
      )}

      {sponsorTableData.length > 0 &&  <>
        {/* <h4 className={inputStyles.subhed}>{author.header}</h4> */}
        { MARKET_KEY != 'SFC' && MARKET_KEY != 'Houston' && MARKET_KEY != 'SanAntonio' && MARKET_KEY != 'Texcom' ? (
                <h4 className={inputStyles.subhed}>{author.header}</h4>
              ):
              (
                <h4 className={inputStyles.subhed}>{author.header.replace('sponsor', 'author')}</h4>
              )}
        <p className={inputStyles.text}>{author.text}</p>

        <div className={inputStyles.personContainer}>
          <Table
            data={sponsorTableData}
            // useKeys={['Lawmaker', 'Email', 'Phone', 'Facebook', 'Twitter']}
            useKeys={['Lawmaker', 'Contact']}
            type={'contact'}
          />
        </div>
      </>}

      {calendar && (
        <>
          {/* <h4 className={inputStyles.subhed}>{hearing.header}</h4>
          <p className={inputStyles.text}>{hearing.text}</p> */}

          <div className={inputStyles.calendarContainer}>
            {calendar.map((item) => (
              <Calendar
                date={item.event_date}
                time={item.event_time}
                location={item.event_location}
                description={item.event_desc}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default GiveInput
